// @flow

import ApiBase from './api-base';
import type { LoggerOptionsType } from '../types/logger';
import type { HttpResponseType } from '../types/http-response';
import type { ApiConstructorArgsType } from '../types/api';

// This can't extend Service, since service creates a logger in it's constructor
export default class Logger extends ApiBase {
  baseUrl: string;

  constructor(args: ApiConstructorArgsType = {}) {
    super(args);
    this.baseUrl = this.conf.path.serviceBase;
  }

  error(options: LoggerOptionsType): Promise<boolean> {
    const defaults = {
      status: 500,
      message: 'Unspecified Error',
      url: '',
    };
    const payload = { ...defaults, ...options };

    return this.post(`${this.baseUrl}/error`, payload)
      .then(res => res.status < 400)
      .catch(() => false);
  }

  requestError(response: HttpResponseType): Promise<boolean> {
    const { status, statusText, data, config: { url } } = response;
    return this.error({
      status,
      url,
      data,
      message: statusText,
    });
  }
}
